module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9542_fushia.6a860759.jpg";